var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImgAlarmNone = function SvgImgAlarmNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.833 68.333a6.957 6.957 0 0 0 13.35 0M40.5 13.333v-7.5",
    stroke: "#DDDEE1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M40.5 13.333c12.273 0 22.222 9.95 22.222 22.223C62.722 56.433 67.167 60 67.167 60H13.833s4.445-5.677 4.445-24.444c0-12.273 9.949-22.223 22.222-22.223Z",
    stroke: "#DDDEE1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgImgAlarmNone;